import React from 'react';
import { PopupHuchaCardContainer2 } from '../../../ui/popup-hucha-card-container';
import { PopupHuchaStandardCardC2 } from './popup-hucha-standard-card-c2';
import { PopupHuchaStandardCardC3 } from './popup-hucha-standard-card-c3';

export const PopupHuchaStandardCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PopupHuchaCardContainer2>
			<PopupHuchaStandardCardC2 />
			<PopupHuchaStandardCardC3 dineroHucha={dineroHucha} />
		</PopupHuchaCardContainer2>
	);
};
